import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, moduleSequences } from 'app/pwa/app.cerebral';
import { getTagIconColor, getTagIcon } from 'utils/challenge';
import { Masonry } from 'dc/Masonry';
import ActivityCard from 'challenge/common/ActivityCard';
import CategoryCard from 'challenge/common/CategoryCard';
import { ActivitiesInfoIcon } from './elements';
import { ActivitiesLabel, ActivitiesTitle } from '../elements';
import { ICON } from 'resources/constants';
import { useText } from 'common/hooks';

const deps = {
  activityKeys: state.challenge.log.computedActivityKeys,
  selectedTag: state.challenge.log.selectedTag,
  showTagModal: moduleSequences.challenge.tagModal.showTagModalClicked,
};

function FilteredActivities({
  activityKeys,
  selectedTag,
  showTagModal,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  const cards = [
    <CategoryCard className={'grid-item'} key={'category-card'} />,
  ];

  activityKeys.forEach(activityKey => {
    cards.push(
      <ActivityCard
        key={activityKey}
        activityKey={activityKey}
        className={'grid-item'}
      />
    );
  });

  return (
    <>
      <ActivitiesLabel $marginBottom="12px">
        <ActivitiesTitle
          icon={getTagIcon(selectedTag)}
          color={getTagIconColor(selectedTag)}
        >
          {`${t(`challenge.tags.${selectedTag}.name`)} (${
            activityKeys.length
          })`}
        </ActivitiesTitle>
        <ActivitiesInfoIcon
          icon={ICON.infoOutline}
          onClick={() =>
            showTagModal({ tag: selectedTag, activityModalKey: null })
          }
        />
      </ActivitiesLabel>
      <Masonry cards={cards} />
    </>
  );
}

export default connect(deps, FilteredActivities);
